import { createTypes } from "../../utils/helpers";


const EQUIPMENT_HOLDING_PROFILE_FETCH_TYPES: any = createTypes('EQUIPMENT_HOLDING_PROFILE_FETCH_TYPES');
const EQUIPMENT_HOLDING_PROFILE_CREATE_TYPES: any = createTypes('EQUIPMENT_HOLDING_PROFILE_CREATE_TYPES');
const EQUIPMENT_HOLDING_PROFILE_REMOVE_TYPES: any = createTypes('EQUIPMENT_HOLDING_PROFILE_REMOVE_TYPES');
const EQUIPMENT_HOLDING_PROFILE_UPDATE_TYPES: any = createTypes('EQUIPMENT_HOLDING_PROFILE_UPDATE_TYPES');


export {
    EQUIPMENT_HOLDING_PROFILE_FETCH_TYPES,
    EQUIPMENT_HOLDING_PROFILE_CREATE_TYPES,
    EQUIPMENT_HOLDING_PROFILE_UPDATE_TYPES,
    EQUIPMENT_HOLDING_PROFILE_REMOVE_TYPES,
};
